<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
@if (msel) {
<div class="frame">
  <section class="header-row elevate">
    <span class="header-cell action-cell">
      @if (canEditMsel || msel.hasRole(loggedInUserId, null).owner) {
      <span>
        <button mat-icon-button (click)="addOrEditInvitation(null, false)" style="outline: none; margin-left: 15px;"
          title="Add an invitation">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
      </span>
      } &nbsp;
    </span>
    <span class="header-cell two-cell">Team</span>
    <span class="header-cell three-cell">Email Domain</span>
    <span class="header-cell two-cell">Expires</span>
    <span class="header-cell one-cell">Max Uses</span>
    <span class="header-cell one-cell">Remaining Uses</span>
  </section>
  <section class="scrolling-region">
    <div class="table">
      <mat-table #table [dataSource]="invitationDataSource" matSort>
        <!-- action column -->
        <ng-container matColumnDef="action">
          <mat-cell *matCellDef="let element" class="cell action-cell">
            <div class="action-div">
              @if (canEditMsel || msel.hasRole(loggedInUserId, null).owner) {
              <button mat-icon-button class="msel-action"
                (click)="addOrEditInvitation(element, true); $event.stopPropagation();"
                title="Edit {{ element.emailDomain }} invitation">
                <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline"
                  title="Edit {{ element.emailDomain }} invitation"></mat-icon>
              </button>
              }
              <button mat-icon-button ngxClipboard [cbContent]="getInvitationLink(element.teamId)"
                title="Copy Invitation Link:  {{ getInvitationLink(element.teamId) }}"
                [disabled]="getInvitationLink(element.teamId).length === 0">
                <mat-icon class="mdi-18px" fontIcon="mdi-content-copy"></mat-icon>
              </button>
              @if (canEditMsel || msel.hasRole(loggedInUserId, null).owner) {
              <button mat-icon-button class="msel-action" (click)="deleteInvitation(element); $event.stopPropagation();"
                title="Delete {{ element.emailDomain }} invitation">
                <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"
                  title="Delete {{ element.emailDomain }} invitation"></mat-icon>
              </button>
              }
            </div>
          </mat-cell>
        </ng-container>
        <!-- teamId Column -->
        <ng-container matColumnDef="teamId">
          <mat-cell *matCellDef="let element" class="cell two-cell">
            {{ getTeamName(element.teamId) }}
          </mat-cell>
        </ng-container>
        <!-- emailDomain Column -->
        <ng-container matColumnDef="emailDomain">
          <mat-cell *matCellDef="let element" class="cell three-cell">
            {{ element.emailDomain }}
          </mat-cell>
        </ng-container>
        <!-- expirationDateTime Column -->
        <ng-container matColumnDef="expirationDateTime">
          <mat-cell *matCellDef="let element" class="cell two-cell">
            {{ element.expirationDateTime | date: 'dd MMM yyyy HH:mm' }}
          </mat-cell>
        </ng-container>
        <!-- maxUsersAllowed Column -->
        <ng-container matColumnDef="usesAllowed">
          <mat-cell *matCellDef="let element" class="cell one-cell">
            <div class="number-cell">{{ element.maxUsersAllowed }}</div>
          </mat-cell>
        </ng-container>
        <!-- userCount Column -->
        <ng-container matColumnDef="usesRemaining">
          <mat-cell *matCellDef="let element" class="cell one-cell">
            <div class="number-cell">{{ element.maxUsersAllowed - element.userCount }}</div>
          </mat-cell>
        </ng-container>
        <!-- row definitions -->
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <!-- No Results Message -->
      @if (invitationDataSource?.filteredData.length === 0) {
      <div class="text no-results">No invitations found</div>
      }
    </div>
  </section>
</div>
}
